import classNames from 'classnames/bind';
import Button from '~/components/Button';
import styles from './Upload.module.scss';
import { HomeIcon } from '~/components/Icons';
import { useNavigate } from 'react-router-dom';
import config from '~/configs';

const cx = classNames.bind(styles);

function Upload() {
    const navigate = useNavigate();

    return (
        <div className={cx('wrapper')}>
            <div className={cx('back-button')}>
                <Button
                    leftIcon={
                        <HomeIcon
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        />
                    }
                    onClick={() => navigate(config.routes.home)}
                >
                    返回首页
                </Button>
            </div>

            <span className={cx('title')}>上传视频</span>
            <span className={cx('subtitle')}>把视频发布到你的账号</span>

            <div className={cx('content')}>
                <div className={cx('uploader')}>
                    <div className={cx('upload')}>
                        <input type="file" accept="video/*" style={{ display: 'none' }} />
                        <div className={cx('upload-card')}>
                            <img
                                src="https://lf16-tiktok-common.ttwstatic.com/obj/tiktok-web-common-sg/ies/creator_center/svgs/cloud-icon1.ecf0bf2b.svg"
                                className={cx('cloud-icon')}
                                alt=""
                            />

                            <div className={cx('text-main')}>
                                <span>选择要上传的视频</span>
                            </div>
                            <div className={cx('text-sub')}>
                                <span>或将文件拖放到此处</span>
                            </div>
                            <div className={cx('text-video-info')}>
                                <span>支持 MP4 或 WebM</span>
                                <span>分辨率 720x1280 以上</span>
                                <span>时长最长 10 分钟</span>
                                <span>文件小于 2GB</span>
                            </div>

                            <Button
                                primary
                                onClick={() => {
                                    alert('演示页面,功能暂不可用 🤡');
                                }}
                            >
                                选择文件
                            </Button>
                        </div>
                    </div>
                </div>

                <div className={cx('form')}>
                    <div className={cx('caption-wrap')}></div>
                    <div className={cx('cover-wrap')}></div>
                    <div className={cx('privacy')}></div>
                    <div className={cx('switch-wrap')}></div>
                    <div className={cx('copyright-wrap')}></div>
                    <div className={cx('btn-wrap')}></div>
                </div>
            </div>
        </div>
    );
}

export default Upload;
